<template>
  <layout-report-step
    :isDone="isDone"
    :title="header.title"
    :description="header.description"
    :image="header.image"
    :debug="header.debug"
    :showFooter="false"
    :hasInstructions="true"
    :instructionPictures="instruction.pictures"
    :instructionText="instruction.text"
    :instructionTitle="instruction.title"
  >
    <v-card max-width="800" class="mx-auto" flat>
      <v-container>
        <v-item-group v-model="selected" mandatory>
          <v-row>
            <v-col v-for="(item, i) in items" :key="i" cols="12">
              <v-item v-slot="{ active, toggle }">
                <v-card class="mx-auto" max-width="500" :elevation="active ? 4 : 2" @click="toggle">
                  <v-img
                    class="white--text"
                    :height="active ? `190` : '85'"
                    :src="item.src"
                    @click="setYear(item)"
                    gradient="to top right, rgba(30, 30, 30, 0.58), rgba(30, 30, 30, 0.58)"
                    :style="active ? `border: 4px solid ${color};` : 'filter: grayscale(100%);'"
                  >
                    <v-card-title>{{ $t(item.title, { bonusPrefix: prefix, bonus: bonus }) }}</v-card-title>
                    <v-card-subtitle v-if="active" class="pb-0">
                      {{ $t(item.text, { bonusPrefix: prefix, bonus: bonus }) }}
                    </v-card-subtitle>
                    <v-card-actions v-if="active">
                      <v-btn icon dark>
                        <v-icon color="white">mdi-heart</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-img>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-item-group>
      </v-container>
    </v-card>
  </layout-report-step>
</template>

<script lang="ts">
import BadConscienceDialog from "@/components/thg/BadConscienceDialog.vue";
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { AssetEnum } from "@/lib/AssetRepository";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { Component, Ref } from "vue-property-decorator";

@Component({
  components: {
    LayoutReportStep
  }
})
export default class ThgYearSelector extends ReportStepMixin implements IReportStep {
  @Ref("badConscienceDialog")
  readonly badConscienceDialog!: BadConscienceDialog;

  screen = ReportScreenEnum.thgYearSelection;

  public header: IReportHeaderData = {
    title: "report.thgYearSelector.title",
    description: "report.thgYearSelector.description"
  };

  public instruction: IReportInstructionData = {
    title: "report.thgYearSelector.instructionTitle",
    text: "report.thgYearSelector.instructionText",
    pictures: [AssetEnum.charging],
    example: AssetEnum.charging,
    display: true
  };

  get bonus() {
    return ThgCreateModule.bonus;
  }

  get prefix() {
    return ThgCreateModule.bonusPrefix;
  }

  get years() {
    return ThgCreateModule.years;
  }

  get selected() {
    return ThgCreateModule.selectedYearId;
  }

  set selected(id) {
    ThgCreateModule.setSelectedYearId(id);
  }

  get company() {
    return ReportModule.partner.companyName;
  }

  get items() {
    return ThgCreateModule.yearSelections;
  }

  get color() {
    return getDefaultPartnerColor();
  }

  get isDone() {
    return true;
  }

  /**
   *
   * @param item
   */
  setYear(item: any) {
    ThgCreateModule.setYears(item.value);
  }

  mounted() {
    this.setCurrentStep();
    if (ThgCreateModule.years.length === 0) {
      ThgCreateModule.setYears(this.items[0].value);
    }
  }
}
</script>

<style scoped>
.center {
  text-align: center;
}
</style>
